/* eslint-disable import/no-cycle */
/**
 * @overview Search page sort order behaviour.
 *
 * @module search/sort-orders
 */

import $ from 'qwery';
import { filterRestaurants, setActiveItems } from './filtering';
import { hideToggleItem } from '../../modules/Toggle';
import { isKeyEvent } from '../../helpers/eventHelper';
import { keys } from '../../constants';


/**
 * Update the sort orders on the page.
 *
 * @param {object[]} cuisines
 */
export function updateSortOrders () {
    const sortOrders = $('[data-sort-order-item]');
    setActiveItems(sortOrders);
}

/**
 * Hides the sort order popover element.
 */
export function hideSortPopover () {
    const popOver = $('[data-toggle]', '[data-sort-order]')[0];
    hideToggleItem(popOver);
}

function onSortOrderClick (event, sortOrder) {
    const findSortOrder = event.target.closest('[data-sort-order]');

    if (findSortOrder !== sortOrder) {
        hideSortPopover();
    }
}

/**
 * Bind events.
 */
function bindEvents () {
    const sortOrder = document.querySelector('[data-sort-order]');

    document.addEventListener('click', event => onSortOrderClick(event, sortOrder));
    document.addEventListener('keydown', event => {
        if (isKeyEvent(event, keys.ENTER)) {
            onSortOrderClick(event, sortOrder);
        }
    });
}

(function initSortOrders () {
    const sortOrders = $('.control-input', '[data-sort-order]');

    if (sortOrders.length > 0) {
        sortOrders.forEach(input => input.addEventListener('change', filterRestaurants));
    }

    bindEvents();
}());
